import { PlatformDeviceInfo } from "./platform-device-info";
import { PlatformType } from "./platform-type";
import { PlatformUserAgent } from "./platform-user-agent";

export class PlatformAmazon extends PlatformUserAgent {

    constructor() {
        super(PlatformType.Amazon)
    }

    public static matchThisPlatform(): boolean {
        return window.navigator.userAgent.toLowerCase().includes("amazon");
    }

    isSupported(): boolean {
        return true;
    }

    async getDeviceInfo(): Promise<PlatformDeviceInfo> {
        const baseInfo = await super.getInfo();
        return new PlatformDeviceInfo(
            baseInfo.macAddress,
            {
                model: "",
                manufacturer: "",
                buildVersion: "",
            },
            {
                macAddress: "",
                signalStrength: null,
                ssid: "",
                status: "",
            },
            {
                status: "",
                macAddress: "",
                cable: "",
            }
        );

    }
    public getOSVersion(): string | null {
        return null;
    }

};